import acceptableUsePolicyContent from './acceptable-use-policy.md?raw';
import platformTosContent from './platform-tos.md?raw';
import privacyPolicyContent from './privacy-policy.md?raw';
import publisherAgreementContent from './publisher-agreement.md?raw';

export const PLATFORM_TOS_VERSION = '1.0.0';
export const PLATFORM_TOS_EFFECTIVE_DATE = '2025-12-29T00:00-05:00';
export const PLATFORM_TOS_REQUIRES_REACCEPTANCE = false;
export const PLATFORM_TOS_CONTENT = platformTosContent;

export const PRIVACY_POLICY_VERSION = '1.0.0';
export const PRIVACY_POLICY_EFFECTIVE_DATE = '2026-01-13T00:00-05:00';
export const PRIVACY_POLICY_CONTENT = privacyPolicyContent;

export const AUP_VERSION = '1.0.0';
export const AUP_EFFECTIVE_DATE = '2025-12-29T00:00-05:00';
export const AUP_CONTENT = acceptableUsePolicyContent;

export const PUBLISHER_AGREEMENT_VERSION = 'GWPA-09252026-01';
export const PUBLISHER_AGREEMENT_EFFECTIVE_DATE = '2026-09-25T00:00-05:00';
export const PUBLISHER_AGREEMENT_REQUIRES_REACCEPTANCE = false;
export const PUBLISHER_AGREEMENT_CONTENT = publisherAgreementContent;
